import { base64ToArray, cryptoPairsFromArray, decryptWithAes, decryptWithRsaBlockCipher, } from '@lucidlink/ts-crypto/crypto';
import { TimeCachedValue } from '#sdk/utils/time-cached-value';
import { CryptoError, InvalidArgumentError, } from '#types/sdk/workspace-client/index';
import { InvalidCryptoError } from '../workspace-crypto.error';
import { MemberCrypto } from './member-crypto';
export class MemberCryptoFromSecretKey extends MemberCrypto {
    member;
    logger;
    constructor(member, logger) {
        super();
        this.member = member;
        this.logger = logger;
        if (!member.ePrivateKeyByInvitationKey) {
            throw new InvalidArgumentError(`Cannot create ${this.constructor.name} with missing member.ePrivateKeyByInvitationKey.`);
        }
    }
    verifyAndGetCurrentMemberKeys() {
        return this.memberKeys.get();
    }
    getWorkspaceCommonKeyArray() {
        return this.workspaceCommonKeyArray.get();
    }
    verifyAndGetCurrentMemberInvitationKeys() {
        return this.invitationKeys.get();
    }
    workspaceCommonKeyArray = new TimeCachedValue(async () => {
        const invitationKeys = await this.invitationKeys.get();
        return await decryptWithRsaBlockCipher(this.member.invitation.eWorkspaceCommonKeyByInvitationKey, invitationKeys.encryptPair.privateKey);
    }, { expirationTime: 'neverExpire' });
    memberKeys = new TimeCachedValue(async () => {
        const invitationKeys = await this.verifyAndGetCurrentMemberInvitationKeys();
        if (!this.member.ePrivateKeyByInvitationKey) {
            throw new CryptoError('Cannot get ePrivateKeyByInvitationKey to get memberKeys');
        }
        const memberPrivateKeyArray = await decryptWithRsaBlockCipher(this.member.ePrivateKeyByInvitationKey, invitationKeys.encryptPair.privateKey);
        const memberPublicKeyArray = base64ToArray(this.member.publicKey);
        const memberKeys = await cryptoPairsFromArray(memberPublicKeyArray, memberPrivateKeyArray);
        await this.verifyPublicPrivateKeyPair(memberKeys.signPair, 'Member public and private keys do not match');
        return memberKeys;
    }, {
        expirationTime: 'neverExpire',
    });
    invitationKeys = new TimeCachedValue(async () => {
        const invitationPrivateKeyArray = (await decryptWithAes(this.getEncryptedInvitationKey(), this.secretKey).catch(() => {
            throw new InvalidCryptoError('Invalid invitation secret');
        })).buffer;
        const invitationPublicKeyArray = base64ToArray(this.member.invitation.publicKey);
        const invitationKeys = await cryptoPairsFromArray(invitationPublicKeyArray, invitationPrivateKeyArray);
        await this.verifyPublicPrivateKeyPair(invitationKeys.signPair, 'Invitation public and private keys do not match');
        return invitationKeys;
    }, {
        expirationTime: 'neverExpire',
    });
}
